import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { UnifiedRestServiceBase } from "./ExpAPIVUnified.resource.js";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ProgressionTemplateResource = class extends UnifiedRestServiceBase {
  constructor() {
    super("progression-templates");
  }
  getByExperimentationGroupAsync(workspaceId, experimentationGroup, includeAncestors = true) {
    return super.getByExperimentationGroupAsync(workspaceId, experimentationGroup, includeAncestors);
  }
};
ProgressionTemplateResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], ProgressionTemplateResource);
const ProgressionTemplateResourceInstance = new ProgressionTemplateResource();
export {
  ProgressionTemplateResource,
  ProgressionTemplateResourceInstance as default
};
//# sourceMappingURL=ProgressionTemplate.resource.js.map
